<template>
  <div>
    <HorseTable
      id="HorseMovementTable"
      :headers="headers"
      title="Entrées / sorties"
      :table-items="horseMovements"
      :add="showAddHorseMovementModal"
      :delete-item="deleteItem"
      :edit-item="editItem"
    >
      <template #item.horse_movement_date="{ item }">
        <span>{{ computeMovementDate(item.horse_movement_date) }}</span>
      </template>

      <template #item.horse_movement_type="{ item }">
        <span>{{ getReferenceLabel(item.horse_movement_type) }}</span>
      </template>
    </HorseTable>
    <HorseMovementModal />
    <ConfirmationModal class="z5" title="Supprimer la session" :activator.sync="confirmationModal" :close-modal="changeConfirmationModal" :action="deleteMovement">
      <template #body>
        <h3 v-if="itemToDelete" class="black--text">
          Êtes-vous sûr de vouloir supprimer {{ getReferenceLabel(itemToDelete.horse_movement_type) }} {{ computeMovementDate(itemToDelete.horse_movement_date) }} de la session?
          Une fois supprimée, cette action ne peut pas être annulée et toutes les ressources associées seront également supprimées des sessions
        </h3>
      </template>
    </ConfirmationModal>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { format } from 'date-fns';
import HorseTable from './HorseTable.vue';
import HorseMovementModal from './HorseMovementModal.vue';
import { EventBus, sendNotification } from '../../../helpers/utils';
import { updateHorse } from '../../../helpers/request';
import { updateHorseOnStore, prepareHorse, deleteHorseMovementsFields } from '../../../helpers/dataManager';
import ConfirmationModal from '../../common/ConfirmationModal.vue';

import store from '@/store';

export default {
  components: { HorseTable, HorseMovementModal, ConfirmationModal },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const confirmationModal = ref(false);

    const changeConfirmationModal = () => {
      confirmationModal.value = !confirmationModal.value;
    };

    const headers = ref([
      { text: 'Date', value: 'horse_movement_date', align: 'center', sortable: false, useTemplate: true },
      { text: 'Nature', value: 'horse_movement_type', align: 'center', sortable: false, useTemplate: true },
      { text: 'Destination', value: 'horse_movement_destination', align: 'center', sortable: false },
      { text: 'Observation', value: 'horse_movement_observation', align: 'center', sortable: false },
      { text: '', value: 'actions', align: 'center', sortable: false }
    ]);
    const panel = ref(0);

    const horseMovements = computed(() => (props.horse.horse_movements || []));

    const getReferenceLabel = key => store.getters.referenceValue('horseMovement', key);

    const computeMovementDate = date => format(new Date(date * 1000), 'yyyy-MM-dd');

    const showAddHorseMovementModal = (horse_movement = null) => {
      EventBus.$emit('showHorseMovementModal', { horse_uuid: props.horse.uuid, horse_movement: horse_movement });
    };

    const itemToDelete = ref(null);

    const deleteItem = async item => {
      itemToDelete.value = item;
      changeConfirmationModal();
    };

    const deleteMovement = async () => {
      const horseMovementArray = [...props.horse.horse_movements];

      // delete movement
      const movementIndex = horseMovementArray.findIndex(m => m.uuid === itemToDelete.value.uuid);
      if (movementIndex !== -1) {
        horseMovementArray.splice(movementIndex, 1);
      }

      const auxiliarHorseMovementArray = horseMovementArray.map(movement => deleteHorseMovementsFields(movement));

      const horseToUpdate = prepareHorse(props.horse, auxiliarHorseMovementArray, true);

      const response = await updateHorse(horseToUpdate);

      if (!response.success) {
        const text = 'Erreur lors de la création';
        sendNotification('error', text);
        changeConfirmationModal();
        return;
      }
      const text = 'Suppression du mouvement équestre';
      updateHorseOnStore(horseToUpdate, response.data[0].data, text);
      changeConfirmationModal();
    };

    const editItem = item => {
      showAddHorseMovementModal(item);
    };

    return { changeConfirmationModal, itemToDelete, editItem, deleteMovement, headers, panel, horseMovements, showAddHorseMovementModal, deleteItem, confirmationModal, getReferenceLabel, computeMovementDate };
  }
};
</script>
